import React from 'react';

import {
  HomeOutlined,
  FormOutlined,
  UserOutlined,
  TeamOutlined,
  BookOutlined,
  DollarCircleOutlined,
  TableOutlined,
  BarChartOutlined,
} from '@ant-design/icons';

/**
 * Admin
 */
const menuList = [
  {
    icon: <HomeOutlined />,
    title: '学生搜索',
    key: '/home',
  },
  {
    icon: <UserOutlined />,
    title: '用户信息',
    key: '/profile',
  },
  {
    icon: <TeamOutlined />,
    title: '\u6559\u5e08\u7ba1\u7406',
    key: '/teacher-management',
  },
  {
    icon: <BookOutlined />,
    title: '\u8bfe\u7a0b\u7ba1\u7406',
    key: '/course-create',
  },
  {
    icon: <DollarCircleOutlined />,
    title: '\u5de5\u8d44\u7ed3\u7b97',
    key: '/salary-settlement',
  },
  {
    icon: <DollarCircleOutlined />,
    title: '\u5de5\u8d44\u7edf\u8ba1',
    key: '/salary-statistic',
  },
  {
    icon: <FormOutlined />,
    title: '登记',
    key: '/form',
    children: [
      {
        icon: '',
        title: '学生登记',
        key: '/form/student',
      },
      {
        icon: '',
        title: '报课登记',
        key: '/form/course',
      },
      {
        icon: '',
        title: '付款登记',
        key: '/form/transaction',
      },
      {
        icon: '',
        title: '上课登记',
        key: '/form/feedback',
      },
    ],
  },
  {
    icon: <TableOutlined />,
    title: '表格',
    key: '/table',
    children: [
      {
        icon: '',
        title: '报课表格',
        key: '/table/enrollment',
      },
      {
        icon: '',
        title: '转账表格',
        key: '/table/transaction',
      },
      {
        icon: '',
        title: '上课表格',
        key: '/table/feedback',
      },
      {
        icon: '',
        title: '结课续课表格',
        key: '/table/course-renewal',
      },
    ],
  },
  {
    icon: <BarChartOutlined />,
    title: '画像',
    key: '/charts',
    children: [
      {
        icon: '',
        title: '公司画像',
        key: '/charts/company',
      },
      {
        icon: '',
        title: '老师画像',
        key: '/charts/teacher',
      },
    ],
  },
];
export default menuList;
